/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APISupplierAutocompleteSuggestion
 */
export interface APISupplierAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APISupplierAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplierAutocompleteSuggestion
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplierAutocompleteSuggestion
     */
    ustId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISupplierAutocompleteSuggestion
     */
    contactNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISupplierAutocompleteSuggestion
     */
    contactEmails?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISupplierAutocompleteSuggestion
     */
    contactPhones?: Array<string>;
}

/**
 * Check if a given object implements the APISupplierAutocompleteSuggestion interface.
 */
export function instanceOfAPISupplierAutocompleteSuggestion(value: object): value is APISupplierAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APISupplierAutocompleteSuggestionFromJSON(json: any): APISupplierAutocompleteSuggestion {
    return APISupplierAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APISupplierAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISupplierAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'ustId': json['ust_id'] == null ? undefined : json['ust_id'],
        'contactNames': json['contact_names'] == null ? undefined : json['contact_names'],
        'contactEmails': json['contact_emails'] == null ? undefined : json['contact_emails'],
        'contactPhones': json['contact_phones'] == null ? undefined : json['contact_phones'],
    };
}

export function APISupplierAutocompleteSuggestionToJSON(value?: APISupplierAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'ust_id': value['ustId'],
        'contact_names': value['contactNames'],
        'contact_emails': value['contactEmails'],
        'contact_phones': value['contactPhones'],
    };
}

